document.addEventListener('DOMContentLoaded', function () {

  // ── Cart count ────────────────────────────────────────────────
  function refreshCart() {
    fetch('/cart.js').then(r => r.json()).then(function (c) {
      document.querySelectorAll('[data-cart-count]').forEach(function (el) {
        el.textContent = c.item_count;
        el.setAttribute('data-count', c.item_count);
      });
    }).catch(function () {});
  }
  refreshCart();
  document.addEventListener('cart:updated', refreshCart);

  // ── Mobile nav ────────────────────────────────────────────────
  var ham  = document.querySelector('.pp-nav__hamburger');
  var mob  = document.querySelector('.pp-nav__mobile');
  if (ham && mob) {
    ham.addEventListener('click', function () {
      mob.classList.toggle('open');
      ham.setAttribute('aria-expanded', mob.classList.contains('open'));
    });
  }

  // ── Scroll reveal ─────────────────────────────────────────────
  var revealEls = document.querySelectorAll('.pp-reveal, .pp-reveal-left, .pp-reveal-right');
  if ('IntersectionObserver' in window && revealEls.length) {
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('pp-visible');
          obs.unobserve(e.target);
        }
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -40px 0px' });
    revealEls.forEach(function (el) { obs.observe(el); });
  } else {
    revealEls.forEach(function (el) { el.classList.add('pp-visible'); });
  }

  // ── Mission dots ──────────────────────────────────────────────
  // Mimic the scattered pill shapes from the screenshot
  var dotsWrap = document.getElementById('pp-dots');
  if (dotsWrap) {
    var shapes = [
      [8,8],[40,14],[10,30],[18,8],[28,28],[14,10],[60,60],
      [10,10],[50,20],[12,40],[8,8],[44,16],[10,36],[20,8]
    ];
    shapes.forEach(function (s) {
      var d = document.createElement('div');
      d.className = 'pp-mission__dot';
      d.style.cssText = 'width:'+s[0]+'px;height:'+s[1]+'px;border-radius:999px;'
        + 'top:'+(Math.random()*90)+'%;left:'+(Math.random()*90)+'%;';
      dotsWrap.appendChild(d);
    });
  }

  // ── Newsletter form ───────────────────────────────────────────
  var nlForm = document.querySelector('.pp-newsletter__form');
  var nlFeedback = document.querySelector('.pp-newsletter__feedback');

  if (nlForm) {
    nlForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var emailInput = nlForm.querySelector('input[type="email"]');
      var submitBtn  = nlForm.querySelector('button[type="submit"]');
      var email = emailInput ? emailInput.value.trim() : '';

      if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
        if (nlFeedback) { nlFeedback.textContent = 'Please enter a valid email.'; nlFeedback.className = 'pp-newsletter__feedback pp-newsletter__feedback--err'; }
        return;
      }

      var btnOrig = submitBtn ? submitBtn.innerHTML : '';
      if (submitBtn) submitBtn.disabled = true;

      // Use Shopify customer contact form
      var data = new URLSearchParams();
      data.append('form_type', 'customer');
      data.append('utf8', '✓');
      data.append('contact[email]', email);
      data.append('contact[tags]', 'newsletter,peteypar-homepage');

      fetch('/contact', { method: 'POST', headers: { 'Content-Type': 'application/x-www-form-urlencoded' }, body: data.toString() })
        .then(function () {
          if (nlFeedback) { nlFeedback.textContent = '✓ You\'re in the squad!'; nlFeedback.className = 'pp-newsletter__feedback'; }
          if (emailInput) emailInput.value = '';
          if (submitBtn) {
            submitBtn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="20 6 9 17 4 12"/></svg> Joined!';
            setTimeout(function () { submitBtn.innerHTML = btnOrig; submitBtn.disabled = false; }, 4000);
          }
          setTimeout(function () { if (nlFeedback) nlFeedback.textContent = ''; }, 6000);
        })
        .catch(function () {
          if (nlFeedback) { nlFeedback.textContent = 'Something went wrong — try again.'; nlFeedback.className = 'pp-newsletter__feedback pp-newsletter__feedback--err'; }
          if (submitBtn) { submitBtn.disabled = false; }
        });
    });
  }

});
